import { API } from 'aws-amplify';

export default {
  send(params) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsSes', { body: params })
        .then((response) => resolve(response)).catch((error) => reject(error));
    });
  },
  serviceAutoReply(params) {
    return new Promise((resolve, reject) => {
      API.post('API', '/customerService/autoReply', { body: params })
        .then((response) => resolve(response)).catch((error) => reject(error));
    });
  },
};
